"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import {
  FaChartLine,
  FaCalendarAlt,
  FaMoneyBillWave,
  FaShoppingCart,
  FaExchangeAlt,
  FaTicketAlt,
  FaPercentage,
  FaFileInvoiceDollar,
} from "react-icons/fa"
import { Line } from "react-chartjs-2";
import moment from "moment";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from "chart.js";
import "../styles/dashboardAdmin.css"

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

const DashboardAdmin = () => {
  const [estatisticas, setEstatisticas] = useState({})
  const [eventos, setEventos] = useState([])
  const [eventoSelecionado, setEventoSelecionado] = useState("")
  const [dataInicio, setDataInicio] = useState("")
  const [dataFim, setDataFim] = useState("")
  const [totalEventos, setTotalEventos] = useState(0)
  const [totalPedidosPendentes, setTotalPedidosPendentes] = useState(0)
  const [totalPedidosPagos, setTotalPedidosPagos] = useState(0)
  const [ticketMedio, setTicketMedio] = useState(0)
  const [totalComissao, setTotalComissao] = useState(0)
  const [vendasPagas, setVendasPagas] = useState(0)
  const [vendasPendentes, setVendasPendentes] = useState(0)
  const [quantidadeVendasPagas, setQuantidadeVendasPagas] = useState(0)
  const [quantidadeVendasPendentes, setQuantidadeVendasPendentes] = useState(0)
  const [loading, setLoading] = useState(true)
  const [grafico, setGrafico] = useState({});
  const [options, setOptions] = useState({});
  const [filtroAtivo, setFiltroAtivo] = useState("ultimos7");
  const [totalSenhas, setTotalSenhas] = useState(0);

  useEffect(() => {
    buscarEventos()
  }, [])

  const buscarEventos = async () => {
    try {
      setLoading(true)
      const response = await axios.get("https://api.ticketdovaqueiro.com/api/events")
      setEventos(response.data)
      setTotalEventos(response.data.length) // ✅ Atualiza o total de eventos
      setLoading(false)
    } catch (error) {
      console.error("❌ Erro ao buscar eventos:", error)
      setLoading(false)
    }
  }
  const buscarTotalSenhas = async () => {
    try {
      const response = await axios.get("https://api.ticketdovaqueiro.com/api/pedidos/total-senhas-admin", {
        params: {
          eventoId: eventoSelecionado || "todos",
          dataInicio: dataInicio || null,
          dataFim: dataFim || null
        }
      });

      setTotalSenhas(response.data.totalSenhas || 0);
    } catch (error) {
      console.error("Erro ao buscar total de senhas:", error);
      setTotalSenhas(0);
    }
  };
  useEffect(() => {
    buscarTotalSenhas();
  }, [eventoSelecionado, dataInicio, dataFim]);
  const buscarEstatisticas = async () => {
    try {
      setLoading(true);
  
      // ✅ Verifica se dataInicio e dataFim estão definidos
      if (!dataInicio || !dataFim) {
        console.warn("⏳ Aguardando filtros serem definidos...");
        return;
      }
  
      const params = {
        dataInicio,
        dataFim
      };
  
      if (eventoSelecionado) {
        params.eventoId = eventoSelecionado;
      }
  
      const token = localStorage.getItem("token");
      const config = { headers: { Authorization: `Bearer ${token}` }, params };
  
      // TOTAL COMISSÃO
      const resComissao = await axios.get(
        "https://api.ticketdovaqueiro.com/api/admin/financeiro/comissao-total",
        config
      );
      setTotalComissao(resComissao.data.totalComissao);
  
      // VENDAS APROVADAS
      const resPagas = await axios.get("https://api.ticketdovaqueiro.com/api/pedidos/total-vendas-pagas", config);
      setVendasPagas(resPagas.data.totalVendasPagas);
  
      // VENDAS PENDENTES
      const resPendentes = await axios.get("https://api.ticketdovaqueiro.com/api/pedidos/total-vendas-pendentes", config);
      setVendasPendentes(resPendentes.data.totalVendasPendentes);
  
      // TICKET MÉDIO
      const resTicket = await axios.get("https://api.ticketdovaqueiro.com/api/pedidos/ticket-medio", config);
      setTicketMedio(resTicket.data.ticketMedio);
  
      // Quantidade Vendas Pagas
      const resQtdPagas = await axios.get("https://api.ticketdovaqueiro.com/api/pedidos/quantidade-vendas-pagas", config);
      setQuantidadeVendasPagas(resQtdPagas.data.quantidadeVendasPagas);
  
      // Quantidade Vendas Pendentes
      const resQtdPendentes = await axios.get("https://api.ticketdovaqueiro.com/api/pedidos/quantidade-vendas-pendentes", config);
      setQuantidadeVendasPendentes(resQtdPendentes.data.quantidadeVendasPendentes);
  
      // 🟢 Reembolsos
      try {
        const resReembolsos = await axios.get("https://api.ticketdovaqueiro.com/api/pedidos/reembolsos", config);
        setEstatisticas(prev => ({
          ...prev,
          quantidadeReembolsos: resReembolsos.data.quantidadeReembolsos || 0,
          totalReembolsos: resReembolsos.data.totalReembolsos || 0
        }));
      } catch (error) {
        console.error("❌ Erro ao buscar reembolsos:", error.response?.data || error.message);
      }
  
      setLoading(false);
    } catch (error) {
      console.error("Erro ao buscar estatísticas:", error);
      setLoading(false);
    }
  };
  // Ao carregar a página, aplicar filtro padrão "últimos 7 dias"
  useEffect(() => {
    aplicarFiltro("ultimos7");
  }, []);
  useEffect(() => {
    buscarEstatisticas()
  }, [dataInicio, dataFim, eventoSelecionado])
  
const aplicarFiltro = (tipo) => {
  setFiltroAtivo(tipo);
  const hoje = new Date();
  let inicio = new Date();
  let fim = new Date();

  switch (tipo) {
    case "ultimos7":
      inicio.setDate(hoje.getDate() - 7);
      break;

    case "ultimos15":
      inicio.setDate(hoje.getDate() - 15);
      break;

    case "ultimos30":
      inicio.setDate(hoje.getDate() - 30);
      break;

    case "ultimos60":
      inicio.setDate(hoje.getDate() - 60);
      break;

    case "ultimos90":
      inicio.setDate(hoje.getDate() - 90);
      break;

    case "ultimos6meses":
      inicio.setMonth(hoje.getMonth() - 6);
      break;

    case "ultimos1ano":
      inicio.setFullYear(hoje.getFullYear() - 1);
      break;

    case "ultimos2anos":
      inicio.setFullYear(hoje.getFullYear() - 2);
      break;

    default:
      setDataInicio("");
      setDataFim("");
      return;
  }

  setDataInicio(inicio.toISOString().split("T")[0]);
  setDataFim(fim.toISOString().split("T")[0]);
};

  
  


  useEffect(() => {
    buscarDashboardAdmin();
    
  }, [dataInicio, dataFim, eventoSelecionado]);

  const buscarDashboardAdmin = async () => {
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          dataInicio,
          dataFim
        }
      };
      
      if (eventoSelecionado && eventoSelecionado.trim() !== "") {
        config.params.eventoId = eventoSelecionado;
      }
      
  
      const res = await axios.get("https://api.ticketdovaqueiro.com/api/admin/dashboard", config);
      const dados = res.data;

    
// === MODO GRÁFICO POR DIA APENAS ===
let labels = [];
let valores = [];

let atual = moment(dataInicio);
const fim = moment(dataFim);

while (atual.isSameOrBefore(fim)) {
  const diaFormatado = atual.format("DD/MM/YYYY");
  labels.push(diaFormatado);
  atual.add(1, "days");
}

valores = labels.map(dia => dados.graficoDias?.[dia] || 0);

  
      setGrafico({
        labels,
        datasets: [
          {
            label: "Total Vendas (R$)",
            data: valores,
            fill: "start",
            backgroundColor: "rgba(255, 231, 13, 0.2)",
            borderColor: "#f5c242",
            tension: 0.4,
            borderWidth: 2,
            pointBackgroundColor: "#f5c242",
          },
        ],
      });
  
      setOptions({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {
              color: "#fff",
              font: {
                size: 14,
              },
            },
          },
          tooltip: {
            mode: "index",
            intersect: false,
            bodyColor: "#fff",
            titleColor: "#fff",
            backgroundColor: "rgba(51, 51, 51, 0.9)",
            padding: 12,
            cornerRadius: 6,
            boxPadding: 6,
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#fff",
              font: {
                size: 12,
              },
            },
            grid: {
              color: "rgba(255, 255, 255, 0.1)",
              drawBorder: false,
            },
          },
          y: {
            beginAtZero: true,
            ticks: {
              color: "#fff",
              font: {
                size: 12,
              },
            },
            grid: {
              color: "rgba(255, 255, 255, 0.1)",
              drawBorder: false,
            },
          },
        },
      });
  
      // Atualizar estatísticas
      setQuantidadeVendasPagas(dados.quantidadePagas || 0);
      setQuantidadeVendasPendentes(dados.quantidadePendentes || 0);
      setVendasPagas(dados.totalPagas || 0);
      setVendasPendentes(dados.totalPendentes || 0);
      setTicketMedio(dados.ticketMedio || 0);
      setTotalEventos(dados.totalEventos || 0);
      setEstatisticas({
        totalReembolsos: dados.totalReembolsos || 0,
        quantidadeReembolsos: dados.quantidadeReembolsos || 0,
      });
  
    } catch (err) {
      console.error("Erro ao buscar dashboard admin:", err);
    }
  };
  
  


  
  return (
    <div className="dashboard-admin">
      <h1>
        <FaChartLine /> Painel Administrativo
      </h1>

      <div className="filtros">
<div className="filtros-data">
  <button
    className={filtroAtivo === "ultimos7" ? "ativo" : ""}
    onClick={() => aplicarFiltro("ultimos7")}
  >
    7 dias
  </button>
   <button
    className={filtroAtivo === "ultimos15" ? "ativo" : ""}
    onClick={() => aplicarFiltro("ultimos15")}
  >
    15 dias
  </button> 
    <button
    className={filtroAtivo === "ultimos30" ? "ativo" : ""}
    onClick={() => aplicarFiltro("ultimos30")}
  >
    30 dias
  </button>
    <button
    className={filtroAtivo === "ultimos60" ? "ativo" : ""}
    onClick={() => aplicarFiltro("ultimos60")}
  >
    60 dias
  </button>
    <button
    className={filtroAtivo === "ultimos90" ? "ativo" : ""}
    onClick={() => aplicarFiltro("ultimos90")}
  >
    90 dias
  </button>
    <button
    className={filtroAtivo === "ultimos6meses" ? "ativo" : ""}
    onClick={() => aplicarFiltro("ultimos6meses")}
  >
    6 meses
  </button>
  <button
    className={filtroAtivo === "ultimos1ano" ? "ativo" : ""}
    onClick={() => aplicarFiltro("ultimos1ano")}
  >
    1 ano
  </button>
  <button
    className={filtroAtivo === "ultimos2anos" ? "ativo" : ""}
    onClick={() => aplicarFiltro("ultimos2anos")}
  >
    2 anos
  </button>
</div>

        <select value={eventoSelecionado} onChange={(e) => setEventoSelecionado(e.target.value)} disabled={loading}>
          <option value="">Todos os Eventos</option>
          {eventos.map((evento) => (
            <option key={evento._id} value={evento._id}>
              {evento.nome}
            </option>
          ))}
        </select>
      </div>
      <div className="grafico-dashboard23">
        {grafico.labels && <Line data={grafico} options={options} height={300} />}
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Carregando estatísticas...</p>
        </div>
        
      ) : (
        
        <div className="estatisticas-container">
          <div className="card">
            <h2>
              <FaFileInvoiceDollar /> Total em Vendas Aprovadas
            </h2>
            <p>{Number(vendasPagas).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</p>
          </div>          
          <div className="card">
            <h2>
              <FaTicketAlt /> Vendas Aprovadas
            </h2>
            <p>{quantidadeVendasPagas}</p>
          </div>
          <div className="card">
            <h2>
              <FaTicketAlt /> Senhas Vendidas
            </h2>
            <p>{totalSenhas}</p>
          </div>          
          <div className="card">
            <h2>
              <FaFileInvoiceDollar /> Total em Vendas Pendentes
            </h2>
            <p>{Number(vendasPendentes).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</p>
          </div>        
          <div className="card">
            <h2>
              <FaShoppingCart /> Pedidos Pendentes
            </h2>
            <p>{quantidadeVendasPendentes}</p>
          </div>            
          <div className="card">
            <h2>
              <FaMoneyBillWave /> Total de Comissão
            </h2>
            <p>{Number(totalComissao).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</p>
          </div>
          <div className="card">
            <h2>
              <FaCalendarAlt /> Total de Eventos
            </h2>
            <p>{totalEventos}</p>
          </div>
          <div className="card">
            <h2>
              <FaPercentage /> Ticket Médio
            </h2>
            <p>{Number(ticketMedio).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</p>
          </div>
          <div className="card">
            <h2>
              <FaExchangeAlt /> Reembolsos
            </h2>
            <p>{estatisticas.quantidadeReembolsos || 0}</p>
          </div>
          <div className="card">
            <h2>
              <FaMoneyBillWave /> Total em Reembolsos
            </h2>
            <p>
              {Number(estatisticas.totalReembolsos || 0).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default DashboardAdmin

